import { SecondaryButton } from "@/components/buttons/SecondaryButton";
import { Button, Modal, Space } from "antd";
import { useTranslation } from "react-i18next";
import { useDownloadCommissionsBatchInputsExport } from "../../../../../common/api/queries";
import { ExportFileType } from "../../../../../common/enums";
import { UUID } from "../../../../../typings/global";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  batchId: UUID;
};

export const ExportInputsFileTypeQuestionModal = ({ isOpen, onClose, batchId }: Props) => {
  const { t } = useTranslation();

  const downloadCommissionsBatchInputsExport = useDownloadCommissionsBatchInputsExport();

  return (
    <Modal
      open={isOpen}
      title={t("commissions.batch.helpers.exportInputsFileTypeQuestion")}
      onCancel={onClose}
      footer={
        <Space>
          <Button
            type="primary"
            onClick={() => {
              downloadCommissionsBatchInputsExport.mutate({
                id: batchId,
                object: { exportFileType: ExportFileType.XLSX },
              });

              onClose();
            }}
          >
            {t("common.exportXlsx")}
          </Button>

          <SecondaryButton
            onClick={() => {
              downloadCommissionsBatchInputsExport.mutate({
                id: batchId,
                object: { exportFileType: ExportFileType.CSV },
              });

              onClose();
            }}
          >
            {t("common.exportCsv")}
          </SecondaryButton>
        </Space>
      }
    />
  );
};
